import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';

import { AuctioneerInvoiceResponse } from '@types';
import { getDateFormat } from '@helpers/datetime';
import { getCurrencyFormat } from '@helpers/formats';
import TableColumn, { TableColumnSortProps } from '@components/Table/TableColumn';
import colorIcoPdf from '@assets/images/color-ico-pdf.svg';

interface Props {
  sort: TableColumnSortProps;
  data: Array<AuctioneerInvoiceResponse>;
  onSortChange: (sort: TableColumnSortProps) => void;
  onDownloadClick: (invoiceId: number) => void;
}

const InvoicesTable: React.FC<Props> = (props) => {
  const handleDetailClick = (e: React.MouseEvent, invoiceId: number) => {
    e.preventDefault();
    props.onDownloadClick(invoiceId);
  };

  return (
    <div style={{ width: '100%' }}>
      <div>
        <h2>Faktury</h2>
      </div>
      <div>
        <Table striped>
          <thead>
          <tr>
            <TableColumn
              sort={props.sort}
              title="Č. faktury"
              className="align-bottom"
              sortField="auctionInvoice.invoiceNumber"
              onSortChange={(val) => props.onSortChange(val)}
            />
            <TableColumn title="Číslo dražby/aukce/soutěže" className="align-bottom" />
            <TableColumn title="Celkem bez DPH" className="align-bottom" />
            <TableColumn title="DPH" className="align-bottom" />
            <TableColumn title="Celkem s DPH" className="align-bottom" />
            <TableColumn
              title="Vystavení"
              className="align-bottom"
              sort={props.sort}
              sortField="auctionInvoice.timeCreated"
              onSortChange={(val) => props.onSortChange(val)}
            />
            <TableColumn
              title="Splatnost"
              className="align-bottom"
              sort={props.sort}
              sortField="auctionInvoice.dateDue"
              onSortChange={(val) => props.onSortChange(val)}
            />
            <TableColumn
              title="Datum zapl"
              sort={props.sort}
              sortField="auctionInvoice.datePaid"
              className="align-bottom text-nowrap"
              onSortChange={(val) => props.onSortChange(val)}
            />
            <TableColumn title="Zaplaceno" className="align-bottom" />
            <th/>
          </tr>
          </thead>
          <tbody>
          {props.data.map((item, index) => (
            <tr key={`list-item-${index}`}>
              <td>{item.invoiceNumber}</td>
              <td>{item.auctionNumber}</td>
              <td>{getCurrencyFormat(item.invoicedPrice)}</td>
              <td>{getCurrencyFormat(item.invoicedPriceVat)}</td>
              <td>{getCurrencyFormat(item.invoicedPriceWithVat)}</td>
              <td>{item.dateOfIssue ? getDateFormat(item.dateOfIssue) : '-'}</td>
              <td>{item.dateDue ? getDateFormat(item.dateDue) : '-'}</td>
              <td>{item.datePaid ? getDateFormat(item.datePaid) : '-'}</td>
              <td>{item.paid ? 'Ano' : 'Ne'}</td>
              <td className="text-right">
                <Link
                  to="/"
                  className="d-inline-flex align-items-center ml-4"
                  onClick={(e) => handleDetailClick(e, item.id)}
                >
                  <img src={colorIcoPdf} alt="ico" className="mr-2" />
                  Faktura
                </Link>
              </td>
            </tr>
          ))}
          {props.data.length < 1 && (
            <tr>
              <td className="text-left" colSpan={100}>
                Nebyla nalezena žádná data.
              </td>
            </tr>
          )}
          </tbody>
        </Table>
      </div>

    </div>
  );
};

export default InvoicesTable;
